import * as React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';

import { AppDataProvider, IntlProvider } from './providers';
import { ProductFinder, ScrollToTop } from './components';
import { AppTheme } from './interfaces';

window.onload = async (): Promise<void> => {
    const root = document.getElementById('product-finder-app');
    const contactsWrapper = document.querySelector('.person-wrapper');

    // If the app cannot be initialised, cancel
    if (!root) {
        return;
    }

    const locale: string = document.querySelector('html').getAttribute('lang');

    const {
        formUri,
        maxFileSize,
        selectionLabel,
        gtagEventTarget,
        privacyUri,
        basename,
        productSelection,
        termsAndConditionsUri,
        appNodeIdentifier,
    } = root.dataset;

    const categoryTree = JSON.parse(root.dataset.categoryTree);
    const products = JSON.parse(root.dataset.products);
    const supplyTypes = JSON.parse(root.dataset.supplyTypes);
    const productsSelection = JSON.parse(root.dataset.productsSelection);
    const translations: { [key: string]: string } = JSON.parse(root.dataset.translations);
    const inBackend: boolean = JSON.parse(root.dataset.inBackend);
    const appNodeDimensions = JSON.parse(root.dataset.appNodeDimensions);
    const allowOrderAsAlways: boolean = JSON.parse(root.dataset.allowOrderAsAlways);
    const isShop: boolean = JSON.parse(root.dataset.isShop);
    const inquiriesOnly: boolean = JSON.parse(root.dataset.inquiriesOnly);
    const orderModeSelectable: boolean = JSON.parse(root.dataset.orderModeSelectable);
    const allowUploads: boolean = JSON.parse(root.dataset.allowUploads);
    const theme: AppTheme = JSON.parse(root.dataset.theme);

    const Router = ({ children }: { children: React.ReactElement[] }) => {
        return inBackend ? (
            <MemoryRouter>{children}</MemoryRouter>
        ) : (
            <BrowserRouter basename={basename}>{children}</BrowserRouter>
        );
    };

    render(
        <Router>
            <ScrollToTop />
            <IntlProvider translations={translations}>
                <AppDataProvider
                    categoryTree={categoryTree}
                    products={products}
                    supplyTypes={supplyTypes}
                    appNodeIdentifier={appNodeIdentifier}
                    appNodeDimensions={appNodeDimensions}
                    formUri={formUri}
                    privacyUri={privacyUri}
                    termsAndConditionsUri={termsAndConditionsUri}
                    selectionLabel={selectionLabel}
                    productsSelection={productsSelection}
                    productSelection={productSelection}
                    contactsWrapper={contactsWrapper}
                    gtagEventTarget={gtagEventTarget}
                    allowOrderAsAlways={allowOrderAsAlways}
                    isShop={isShop}
                    inquiriesOnly={inquiriesOnly}
                    orderModeSelectable={orderModeSelectable}
                    allowUploads={allowUploads}
                    locale={locale}
                    maxFileSize={parseInt(maxFileSize)}
                    theme={theme}
                >
                    <ProductFinder />
                </AppDataProvider>
            </IntlProvider>
        </Router>,
        root
    );
};
